import * as ng from 'angular';
import * as Dto from './interfaces';
import * as Core from './../core';

interface IReCaptchaValidationResource extends ng.resource.IResourceClass<Dto.IReCaptchaValidation> {
    getReCaptcha2TokenValidationResult(params: any): Dto.IReCaptchaValidation;
    getReCaptcha3TokenValidationResult(params: any): Dto.IReCaptchaValidation;
}

let ReCaptchaValidationResourceFactory = function ($resource: ng.resource.IResourceService, exception: Core.IException,
    logger: Core.ILogger, SiteConfig: Core.ISiteConfigService): IReCaptchaValidationResource {
    return <IReCaptchaValidationResource>$resource(
        SiteConfig.getResourceUri("reCaptchaValidation"),
        { } as any,
        new ReCaptchaValidationResource(SiteConfig) as any
    );
};

ReCaptchaValidationResourceFactory.$inject = ['$resource', 'exception', 'logger', 'SiteConfig'];

class ReCaptchaValidationResource {

    constructor(private SiteConfig: Core.ISiteConfigService) {
    }

    public getReCaptcha2TokenValidationResult: ng.resource.IActionDescriptor = {
        method: 'GET',
        url: this.SiteConfig.getResourceUri("reCaptchaValidation") + '/v2',
        params: {
            id: '@id',
            token: '@token'
        }
    };

    private getReCaptcha3TokenValidationResult: ng.resource.IActionDescriptor = {
        method: 'GET',
        url: this.SiteConfig.getResourceUri("reCaptchaValidation") + '/v3',
        params: {
            id: '@id',
            token: '@token'
        }
    };
}

let ReCaptchaValidation = {
    name: "ReCaptchaValidation",
    factory: ReCaptchaValidationResourceFactory
};

export { ReCaptchaValidation, IReCaptchaValidationResource }
export default ReCaptchaValidation;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/data/recaptcha-validation.ts